import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import brandLogo from './../images/brand-logo-inverse-dark.png';

class AgradecimientoContainer extends Component {

    render = () => {
        return (
            <div className="overlay">
                <div id="content" className="container">
                    <div className="store-singup">
                        <div className="panel panel-default short">
                            <div className="panel-content">
                                <div className="panel-heading-signup text-center">
                                    <img height="64px" alt="IOS OFFICES" src={brandLogo} />
                                </div>
                                <div className="container-fluid container-padding text-center">
                                    <h2>
                                        <Trans>venta_linea.agradecimiento.title</Trans>
                                    </h2>
                                    <h5>
                                        <Trans>venta_linea.agradecimiento.subtitle</Trans>
                                    </h5>
                                    <p>
                                        <Trans>venta_linea.agradecimiento.description</Trans>
                                    </p>
                                    <div className="form-group">
                                        <Link to="/" className="btn btn-primary btn-full-width">
                                            <Trans>venta_linea.agradecimiento.btn_cta</Trans>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(AgradecimientoContainer);


// WEBPACK FOOTER //
// ./src/store/AgradecimientoContainer.js